module.exports = __webpack_public_path__ + "static/media/plans-icon.9836f0bd.svg";